export default {
  productName: 'Heart Rate Monitor',
  pathId: 'fightcamp-heart-rate-monitor',
  description: 'Heart Rate Monitor that syncs with the FightCamp app for live heart rate tracking. Sweat-resistant, low-profile, high performance.',
  shortDescription: 'Heart Rate Monitor',
  testShopifyId: 'gid://shopify/Product/7091661111385',
  prodShopifyId: 'gid://shopify/Product/7667444646124',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x825/3b51509c0e/dscf0234.jpg',
    alt: 'FightCamp heart rate monitor',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/352x352/42889a5470/fc-heart-rate-monitor-person-001.png',
    alt: 'FightCamp heart rate monitor',
  },
  includesModalCopy: {},
  assets: [
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/3b51509c0e/dscf0234.jpg',
      alt: 'FightCamp heart rate monitor',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/18dc77facb/dscf0232-2.jpg',
      alt: 'FightCamp heart rate monitor close up',
    },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        'Heart Rate tracking during workout',
        'Integrates with the FightCamp app',
        'Detachable monitor, from strap',
        'Operates on a replaceable coin battery with a life expectancy of 8-12 months - no charger needed',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Adjustable elastic strap fits chest sizes 26” - 38”',
        'Soft, durable, and flexible chest strap for a secure and comfortable fit',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Made with moisture resistant nylon and spandex fabric',
        'Wipe strap with soft damp cloth after use',
      ],
    },
  ],
};
